module.exports = __webpack_public_path__ + "static/media/Ellipse 4.c56f0109.png";